import React from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useTheme } from "../context/ThemeContext";
import "./Footer.css";

interface FooterProps {
  variant?: "landing" | "app";
}

export default function Footer({ variant = "app" }: FooterProps) {
  const { theme, toggleTheme } = useTheme();

  return (
    <footer className={`podium-footer podium-footer--${variant}`}>
      <Container className="podium-footer-inner">
        <span className="podium-footer-brand">
          Powered by{" "}
          <Link to="/" className="podium-footer-brand-link">
            Podium
          </Link>
        </span>
        <div className="podium-footer-links">
          <Link to="/about" className="podium-footer-link">
            About
          </Link>
          <Link to="/privacy" className="podium-footer-link">
            Privacy
          </Link>
          <Link to="/terms" className="podium-footer-link">
            Terms
          </Link>
          <button
            onClick={toggleTheme}
            className="podium-footer-theme-toggle"
            aria-label={`Switch to ${
              theme === "light" ? "dark" : "light"
            } mode`}
            title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
          >
            <i
              className={`bi bi-${theme === "light" ? "moon-stars" : "sun"}`}
            ></i>
          </button>
        </div>
      </Container>
    </footer>
  );
}
